import React, { useEffect, useState } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

function ChangeLogWeekly({ chart_data = [] }) {
  const [chartConfig, setChartConfig] = useState({
    labels: [],
    datasets: [],
  });

  const [options, setOptions] = useState({});
  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  useEffect(() => {
    if (!chart_data?.length) {
      setChartConfig({
        labels: [],
        datasets: [],
      });
      return;
    }

    // Financial Year Week Order:
    // 14,15,16....52,53,1,2,3....13
    const sortedData = [...chart_data].sort((a, b) => {
      const wa = Number(a.week_no);
      const wb = Number(b.week_no);

      const orderA = wa >= 14 ? wa : wa + 53;
      const orderB = wb >= 14 ? wb : wb + 53;

      return orderA - orderB;
    });

    const labels = sortedData.map((item) => item.week_no);

    const currentYearRevenue = sortedData.map(
      (item) => Number(item.current_year_revenue || 0)
    );

    const previousYearRevenue = sortedData.map(
      (item) => Number(item.previous_year_revenue || 0)
    );

    const currentFY =
      new Date().getMonth() + 1 >= 4
        ? new Date().getFullYear()
        : new Date().getFullYear() - 1;

    const currentFYLabel = `${currentFY}-${currentFY + 1}`;
    const previousFYLabel = `${currentFY - 1}-${currentFY}`;

    setChartConfig({
      labels,
      datasets: [
        {
          label: currentFYLabel,
          data: currentYearRevenue,
          borderWidth: 3,
          tension: 0.35,
          fill: false,
          pointRadius: 4,
          pointHoverRadius: 6,
        },
        {
          label: previousFYLabel,
          data: previousYearRevenue,
          borderWidth: 3,
          tension: 0.35,
          fill: false,
          pointRadius: 4,
          pointHoverRadius: 6,
        },
      ],
    });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,

      interaction: {
        mode: "index",
        intersect: false,
      },

      plugins: {
        legend: {
          position: "top",
        },

        datalabels: {
          display: false,
        },

        tooltip: {
          callbacks: {
            title: (context) => {
              const idx = context[0].dataIndex;

              return `Week ${
                sortedData[idx].week_no
              } (${sortedData[idx].current_week})`;
            },

            label: (context) => {
                const revenue = Math.round(context.raw);

                return `${context.dataset.label}: ₹ ${formatNumber(revenue)}`;
                },
          },
        },
      },

      scales: {
        x: {
          title: {
            display: true,
            text: "Financial Year Week",
          },

          ticks: {
            autoSkip: false,
            maxRotation: 90,
            minRotation: 90,
          },
        },

        y: {
          beginAtZero: true,

          title: {
            display: true,
            text: "Revenue",
          },

          ticks: {
            callback: (value) => `₹ ${formatNumber(value)}`,
          },
        },
      },
    });
  }, [chart_data]);

  return (
    <div
      style={{
        width: "100%",
        minWidth: "100%",
        height: "450px",
        position: "relative",
      }}
    >
      <Line data={chartConfig} options={{...options, responsive: true, maintainAspectRatio: false,}} />
    </div>
  );
}

export default ChangeLogWeekly;